function CountryPt({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23 5H9V19H23V5Z" fill="#FF0000" />
      <path d="M9 5H1V19H9V5Z" fill="#006600" />
      <path
        d="M9 15C10.6569 15 12 13.6569 12 12C12 10.3431 10.6569 9 9 9C7.34315 9 6 10.3431 6 12C6 13.6569 7.34315 15 9 15Z"
        fill="#FFEE00"
      />
    </svg>
  );
}
function CountryEn({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      className={className}
      width="22"
      height="14"
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H22V14H0V0Z" fill="#000066" />
      <path
        d="M4.33922e-05 0L-2.74181e-05 1.5L19.5 14H22V12.5L2.50004 0H4.33922e-05ZM22 0V1.5L2.5 13.9999H4.33922e-05V12.6L19.5 0H22Z"
        fill="white"
      />
      <rect x="9" width="4" height="14" fill="white" />
      <rect y="9" width="4" height="22" transform="rotate(-90 0 9)" fill="white" />
      <path d="M0 14V13.5L7 9H8.97317L1.63974 14H0Z" fill="#C80000" />
      <path d="M8.97314 5L1 0H0V1L6.5 5H8.97314Z" fill="#C80000" />
      <path d="M22 0V0.5L14.5 5H13L20.5 0H22Z" fill="#C80000" />
      <path d="M13 9L20.9731 14H22V13L15.5 9H13Z" fill="#C80000" />
      <rect y="6" width="22" height="2" fill="#C80000" />
      <rect x="10" y="14" width="14" height="2" transform="rotate(-90 10 14)" fill="#C80000" />
    </svg>
  );
}

export const CountriesFlagsForLanguage: Record<
  string,
  React.ComponentType<{ className?: string }>
> = {
  pt: CountryPt,
  en: CountryEn,
};
